import { RawLink } from '@/shared/ui/RawLink'
import { homePagePath } from '@/shared/constants/homeConstants'
import { Box } from '@mui/material'
import React from 'react'
import useAppSkin from '../hooks/useAppSkin'
import { useVisibilityStore } from '../store'
import packageJson from '../../../package.json'

const Logo = () => {
    const { setHomeContentVisible } = useVisibilityStore()
    const { appMenuLogo } = useAppSkin()
    const handleClick = () => {
        setHomeContentVisible()
    }
    const { appVersion } = packageJson
    const logoStyle = {
        width: 'max-content',
        mr: { xs: '16px', sm: '40px' },
        mb: '6px',
        '& > svg, img': {
            // minWidth: '90px',
            // maxWidth: '114px',
            objectFit: 'contain',
        },
        '&:hover': {
            cursor: 'pointer',
        },
    }

    return (
        <RawLink to={homePagePath}>
            <Box onClick={handleClick} sx={logoStyle}>
                <img
                    src={appMenuLogo}
                    alt="company logo"
                    width="100px"
                    height="35px"
                />
                <span
                    style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#fff',
                    }}>
                    v{appVersion}
                </span>
            </Box>
        </RawLink>
    )
}

export { Logo }
